module.exports = __webpack_public_path__ + "media/images/icons/check-b2c7eedeb12b4c06341f2bb77fca8b53.svg";